import styled from '@emotion/styled';
import { InputLabel as MuiInputLabel } from '@material-ui/core';

export const InputLabel = styled(MuiInputLabel)`
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  margin-bottom: 2px;
`;
